import WithDraw from "./WithDraw";
import Tickets from "./Tickets";
import PizzaMoney from "./PizzaMoney";
import SendFanEmail from "./SendFanEmail";
const repositories = {
  setWithdraw: WithDraw,
  setTickets: Tickets,
  addPizzaMoney: PizzaMoney,
  fanEmail: SendFanEmail,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
};
